import standardAPI from '@/api/standard_items';

const state = {
  price_types: [],
  price_types_status: '',
  price_types_MetaData: {},
  price_types_page: 1,
  price_types_perPage: 10,
};

const responseUrl = '/world-tours/price-types';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_price_types ({ commit }, getOptions) {
    commit('PRICE_TYPES_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('PRICE_TYPES_SUCCESS', response);
            commit('PRICE_TYPES_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('PRICE_TYPES_READY');
            reject(response);
          } else {
            commit('PRICE_TYPES_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_price_type ({ commit, dispatch }, itemData) {
    commit('PRICE_TYPES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('PRICE_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  edit_price_type ({ commit, dispatch }, itemData) {
    commit('PRICE_TYPES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('PRICE_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  remove_price_type ({ commit, dispatch }, itemData) {
    commit('PRICE_TYPES_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('PRICE_TYPES_READY');
          reject(response);
        }
      });
    });
  },
  reorder_price_type ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_price_type_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.price_types_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.price_types_perPage = max;
  },
  PRICE_TYPES_READY: (state) => {
    state.price_types_status = 'ready';
  },
  PRICE_TYPES_REQUEST: (state) => {
    state.price_types_status = 'loading';
  },
  PRICE_TYPES_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.price_types_MetaData.meta = response.meta;
      state.price_types_MetaData.links = response.links;
    }
    if (response && response.data) {
      state.price_types = response.data.map((category) => {
        category.checked = false; // need for some pages where we can select price_types
        return category;
      }) || [];
    }
    state.price_types_status = 'success';
  },
  PRICE_TYPES_ERROR: (state) => {
    state.price_types_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
